import React from 'react';
import { Link } from 'react-router-dom';

const sitemap = [
  {
    category: '🏠 Main Pages',
    links: [
      { label: 'Home', to: '/' },
      { label: 'About Us', to: '/about' },
      { label: 'Services', to: '/services' },
      { label: 'Government', to: '/government' },
      { label: 'Portfolio', to: '/portfolio' },
      { label: 'Contact Us', to: '/contact' },
    ],
  },
  {
    category: '🏢 Company Info',
    links: [
      { label: 'Overview', to: '/company/overview' },
      { label: 'Our Expertise', to: '/company/expertise' },
      { label: 'Vision & Mission', to: '/company/vision-mission' },
      { label: 'Management Team', to: '/company/management-team' },
      { label: 'Why EGB', to: '/company/why-egb' },
      { label: 'Awards', to: '/company/awards' },
    ],
  },
  {
    category: '⚙️ Our Strategy',
    links: [
      { label: 'Business Model', to: '/strategy' },
      { label: 'Process Methodology', to: '/strategy' },
      { label: 'Quality Assurance', to: '/strategy' },
      { label: 'Development Infrastructure', to: '/strategy' },
    ],
  },
  {
    category: '🛠️ Services',
    links: [
      { label: 'Web Services', to: '/services' },
      { label: 'Multimedia & Graphic Design', to: '/services' },
      { label: 'SEO & Digital Marketing Services', to: '/services' },
      { label: 'Software Development', to: '/services' },
      { label: 'Technology Support', to: '/services' },
      { label: 'Back Office Support', to: '/services' },
      { label: 'Medical Services', to: '/services' },
      { label: 'Mobile App Development', to: '/services' },
      { label: 'AI Services ✨', to: '/ai-services' },
      { label: 'Training & Development', to: '/training' },
    ],
  },
  {
    category: '🧠 AI Services',
    links: [
      { label: 'AI Strategy & Consulting', to: '/ai-services' },
      { label: 'Machine Learning Solutions', to: '/ai-services' },
      { label: 'Generative AI Integration', to: '/ai-services' },
      { label: 'AI-Powered Automation', to: '/ai-services' },
      { label: 'Natural Language Processing', to: '/ai-services' },
      { label: 'Computer Vision', to: '/ai-services' },
      { label: 'AI Data Analytics', to: '/ai-services' },
    ],
  },
  {
    category: '📚 Training & Development',
    links: [
      { label: 'Web Technologies', to: '/training' },
      { label: 'Software Development', to: '/training' },
      { label: 'Database Technologies', to: '/training' },
      { label: 'Mobile App Development', to: '/training' },
      { label: 'Digital Marketing', to: '/training' },
      { label: 'IT Infrastructure & Support', to: '/training' },
      { label: 'Graphic Design & Multimedia', to: '/training' },
      { label: 'Soft Skills & Management', to: '/training' },
    ],
  },
  {
    category: '💼 Careers',
    links: [
      { label: 'Current Openings', to: '/careers' },
      { label: 'Send Your Resume', to: '/contact' },
    ],
  },
  {
    category: '📄 Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'FAQ', to: '/faq' },
      { label: 'Terms of Use', to: '#' },
    ],
  },
];

const Sitemap = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Sitemap</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>A complete overview of all pages on our website</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {sitemap.map((section, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100 p-4 rounded-4">
                <h6 className="fw-bold mb-3" style={{ color: '#1a56db' }}>{section.category}</h6>
                <ul className="list-unstyled mb-0">
                  {section.links.map((link, j) => (
                    <li key={j} className="mb-2">
                      <Link
                        to={link.to}
                        className="text-decoration-none text-muted d-flex align-items-center gap-2"
                        style={{ fontSize: 14 }}
                      >
                        <span style={{ color: '#1a56db' }}>›</span> {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Sitemap;
